import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  title: string;
  intro: string;
  sectionLabel?: string;
};

const PageHero: React.FC<Props> = ({ title, intro, sectionLabel = 'Section Overview' }) => {
  return (
    <section className="bg-[#f0f2f4]">
      <div className="mx-auto max-w-screen-2xl px-8 pt-14 pb-10">
        <nav className="mb-6 flex items-center gap-1 text-sm text-on-surface-variant">
          <Link to="/" className="hover:text-primary transition-colors">
            Home
          </Link>
          <span>/</span>
        </nav>
        <h1 className="mb-4 text-5xl font-bold tracking-tight text-primary md:text-6xl">
          {title}
        </h1>
        <p className="max-w-4xl text-base leading-relaxed text-on-surface-variant md:text-lg">
          {intro}
        </p>
        <div className="mt-10 flex items-center">
          <div className="h-[3px] flex-1 bg-primary/90" />
          <span className="px-3 text-sm font-semibold text-primary">{sectionLabel}</span>
          <div className="h-[3px] flex-1 bg-primary/90" />
        </div>
      </div>
    </section>
  );
};

export default PageHero;
